var submitted = false;
initWholesaleInquiry();

function initWholesaleInquiry() {
  try {
    $(document).ready(function(){
      if (window.location.href.indexOf('?test') !== -1) {
        showThankyouPopup();
        return;
      }

      if (window.location.href.indexOf('?ajax') !== -1) {
        var variantId = 123;
        var quantity = 5;
        //var price = 12.34;

        $.ajax({
          type: 'POST',
          url: 'https://apistaging.vitalityextracts.com/shopify/rest/analytics/addtocart',
          data: {
            'variant_id': variantId,
            'quantity': quantity,
            //'price': price,
          },
          success:function(data) {
            //console.log('SUCCESS', data); // this doesn't get triggered
          },
          error: function (xhr, ajaxOptions, thrownError) {
            //console.log('ERROR', xhr, ajaxOptions, thrownError);
            return false;
          },
          timeout: 1000
        });
        return;
      }

      var question=jQuery('#question');
      question.val(parseInt(Math.random()*5+10)+' + '+parseInt(Math.random()*5+10));
        $("#contactFormSubmit").click(function(e){
          if (submitted) {
            return;
          }
          e.preventDefault();

          jQuery('.error-contact').remove();
      var cfname=jQuery('#contactFormfirstname').val();
      var clname=jQuery('#contactFormlastname').val();
      var cemail=jQuery('#contactFormemailaddress').val();
      var cmpname=jQuery('#contactFormcompanyname').val();
      var contactFormposition= jQuery('#contactFormposition').val();
      var contactFormaddress= jQuery('#contactFormaddress').val();
      var contactFormcity= jQuery('#contactFormcity').val();
      var contactFormzipcode= jQuery('#contactFormzipcode').val();
      var contactFormphonenumber= jQuery('#contactFormphonenumber').val();
      var contactFormtypeofbusiness= jQuery('#contactFormtypeofbusiness').val();
     var pleasedescribeyourtypeofbusiness= jQuery('#pleasedescribeyourtypeofbusiness').val();









      var counterror=0;

      if(cfname=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormfirstname').after('<p class="error-contact error-pedding-contact">Please enter first name.</p>');
      }


      if(clname=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormlastname').after('<p class="error-contact error-pedding-contact">Please enter last name.</p>');
      }

      if(cemail=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormemailaddress').after('<p class="error-contact error-pedding-contact">Please enter email address.</p>');
      }
      else
      {
        var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
        if (!filter.test(cemail)) {

          counterror=counterror+1;
          jQuery('#contactFormemailaddress').after('<p class="error-contact error-pedding-contact">Please enter valid email address.</p>');

        }

      }

      if(cmpname=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormcompanyname').after('<p class="error-contact error-pedding-contact">Please enter company name.</p>');
      }


      if(contactFormposition=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormposition').after('<p class="error-contact error-pedding-contact">Please enter position.</p>');
      }


      if(contactFormaddress=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormaddress').after('<p class="error-contact error-pedding-contact">Please enter address.</p>');
      }

      if(contactFormcity=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormcity').after('<p class="error-contact error-pedding-contact">Please enter city.</p>');
      }

     if(contactFormzipcode=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormzipcode').after('<p class="error-contact error-pedding-contact">Please enter zipcode.</p>');
      }

       if(contactFormphonenumber=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormphonenumber').after('<p class="error-contact error-pedding-contact">Please enter phone number.</p>');
      }


      if(contactFormtypeofbusiness=='')
      {
        counterror=counterror+1;
        jQuery('#contactFormtypeofbusiness').after('<p class="error-contact error-pedding-contact">Please enter type of business.</p>');
      }


        if(pleasedescribeyourtypeofbusiness=='')
      {
        counterror=counterror+1;
        jQuery('#pleasedescribeyourtypeofbusiness').after('<p class="error-contact error-pedding-contact"> Please describe your type of business.</p>');
      }


          if (eval($("#question").val()) != $("#answer").val()) {
          counterror=counterror+1;
        jQuery('#answer').after('<p class="error-contact error-pedding-contact">Please enter valid answer.</p>');
          }







      if(counterror>0)
      {
        return false;
      }




         var cfname1=jQuery('#contactFormfirstname').val();
      var clname1=jQuery('#contactFormlastname').val();
      var cemail1=jQuery('#contactFormemailaddress').val();
      var cmpname1=jQuery('#contactFormcompanyname').val();
      var contactFormposition1= jQuery('#contactFormposition').val();
      var contactFormaddress1= jQuery('#contactFormaddress').val();
      var contactFormaddress21= jQuery('#contactFormaddress2').val();
      var contactFormcity1= jQuery('#contactFormcity').val();
      var contactFormQuestionType1= jQuery('#contactFormQuestionType').val();
      var contactFormzipcode1= jQuery('#contactFormzipcode').val();
      var contactFormphonenumber1= jQuery('#contactFormphonenumber').val();
     // var contactFormfaxnumber1= jQuery('#contactFormfaxnumber').val();
      var contactFormtypeofbusiness1= jQuery('#contactFormtypeofbusiness').val();
      var contactFormwebsite1= jQuery('#contactFormwebsite').val();
      var contactannualrevenue1= jQuery('#contactannualrevenue').val();
      var pleasedescribeyourtypeofbusiness1= jQuery('#pleasedescribeyourtypeofbusiness').val();

        //var dataString = 'entry.1223306879='+cfname1+'&entry.358687712='+clname1+'&entry.1085901440='+cemail1+'&entry.470109928='+cmpname1+'&entry.1898266725='+contactFormposition1+'&entry.840224635='+contactFormaddress1+'&entry.879306399='+contactFormaddress21+'&entry.737787801='+contactFormcity1+'&entry.1039391534='+contactFormQuestionType1+'&entry.2045901865='+contactFormzipcode1+'&entry.1747439732='+contactFormphonenumber1+'&entry.2084213358='+contactFormtypeofbusiness1+'&entry.390225701='+contactFormwebsite1+'&entry.1036549019='+contactannualrevenue1+'&entry.537050043='+pleasedescribeyourtypeofbusiness1;
          var dataString = 'entry.1315750865='+cfname1+'&entry.369746197='+clname1+'&entry.1674417777='+cemail1+'&entry.889032713='+cmpname1+'&entry.1554390703='+contactFormposition1+'&entry.1548778604='+contactFormaddress1+'&entry.1839188488='+contactFormaddress21+'&entry.1627505824='+contactFormcity1+'&entry.1409238824='+contactFormQuestionType1+'&entry.1488793030='+contactFormzipcode1+'&entry.108457456='+contactFormphonenumber1+'&entry.1225451551='+contactFormtypeofbusiness1+'&entry.1690158601='+contactFormwebsite1+'&entry.585673695='+contactannualrevenue1+'&entry.1003348954='+pleasedescribeyourtypeofbusiness1;

      //console.log(dataString);

    $.ajax({
      type:'POST',
      data:dataString,
     // url:'https://docs.google.com/a/commerceacceleration.com/forms/d/e/1FAIpQLSf5XC-aMu5dqKtyUKGq1MyhUm9eIqDzrL7Q-vSLfDNOSu_SSA/formResponse',
        url:'https://docs.google.com/forms/d/e/1FAIpQLSfKC2trnjh_Jz2-X_lh_GMGSh8KtVooIiBlnoPfNwhn2zYDyw/formResponse',
      success:function(data) {
       /// jQuery('.wholesale-success').show();





      }    ,
        error: function (xhr, ajaxOptions, thrownError) {
         // alert(xhr.status);
         // alert(thrownError);
       //   alert(xhr.status);
          if(xhr.status===0){
            //jQuery('#contact_form').submit();
            showThankyouPopup();
          }
          return false;

        }


    });


      });




    });
  } catch (ob) {
    setTimeout(function() { initWholesaleInquiry(); }, 100);
  }
}

function showThankyouPopup() {
  $('#popup1').show();
  $('.thank-you_popup').animate({ opacity: 1 }, 50);

  $(".close-pop").click(function(){
      window.location = '/';
  });
}
